import { App } from 'vue';

import BaseEvaluator from './BaseEvaluator';

export default class NotInEvaluator extends BaseEvaluator {
  vue: App;

  constructor(fieldName, friendlyFieldName, model, mutator = null, vue: App = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'not_in';
    this.vue = vue;
  }

  validate() {
    this.isValid = super.validate();

    if (this.value === undefined || this.value === null) {
      return this.isValid;
    }

    let list;
    if (this.mutator[0] in this.model) {
      list = this.model[this.mutator[0]];
    } else {
      list = JSON.parse(this.mutator[0]);
    }

    list = list.map((x) => x.trim().toLowerCase());
    const cleanValue = this.value.trim().toLowerCase();

    this.isValid = !list.includes(cleanValue);

    return this.isValid;
  }
}
